import { Component, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { AlertService } from './shared/service/alert.service';
import { ThemeService } from './shared/service/theme.service';
import { UpdateService } from './shared/service/update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'giantsms';
  updateAvailable = false;
  message;

  constructor(
    private updates: SwUpdate,
    private alert: AlertService,
    private updateService: UpdateService,
    private themeService: ThemeService,
  ) {
    updates.available.subscribe(event => {
      this.updateAvailable = true;
      this.updateService.showUpdate();
    });
  }

  ngOnInit(): void {
    this.themeService.initialize();
  }
}
